import { useMemo } from "react";
import { useQuery } from "react-query";
import { ApiConstant, KeyConstant } from "const";
import { ApiUtils, HumpUtils, StorageUtils } from "utils";

export default function useUserGroups(accountId, enabled = true) {
  const branchId = StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_ID);

  const query = useQuery({
    queryKey: [ApiConstant.REACT_QUERY_KEYS.getUserGroups, accountId, branchId],
    queryFn: async () => {
      if (!accountId) return [];

      const params = {
        branch_id: branchId,
        branchId: branchId,
        account_id: accountId,
        accountId: accountId,
        paging: 0,
        limit: 1000,
        offset: 0,
        asc: 1,
      };

      const response = await ApiUtils.createApiWithToken(false).get(ApiConstant.GET_CHANNEL_LIST, params);

      if (response.data?.status === ApiConstant.STT_OK) {
        const rawList = response.data?.data?.data || response.data?.data?.list || response.data?.data || [];
        const camelized = HumpUtils.camelizeKeys(rawList);

        return camelized
          .filter(item => item.groupType === 1 || item.groupType === 2)
          .map(item => {
            let groupName = item.groupType === 2 ? "Kênh" : "Nhóm";
            try {
              const parsed = JSON.parse(item.name || "{}");
              if (parsed.name && typeof parsed.name === "string" && parsed.name.trim() !== "") {
                groupName = parsed.name.trim();
              }
            } catch (e) {
              if (item.name && typeof item.name === "string" && !item.name.trim().startsWith("{")) {
                groupName = item.name.trim();
              }
            }
            return {
              ...item,
              groupName,
            };
          });
      }

      throw response.data;
    },
    enabled: Boolean(accountId && enabled),
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });

  const allItems = query.data || [];

  const channels = useMemo(() => allItems.filter(item => item.groupType === 2), [allItems]);
  const groups = useMemo(() => allItems.filter(item => item.groupType === 1), [allItems]);

  return {
    allItems,
    channels,
    groups,
    totalCount: allItems.length,
    channelCount: channels.length,
    groupCount: groups.length,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    refetch: query.refetch,
  };
}
